import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

// AUTH 0 calls should be ASYNC !!!

interface Props {
  children: {}
}

export const UserProfile: React.FC<Props> = ({children}) => {
  const { isAuthenticated, user, getAccessTokenSilently } = useAuth0();
  const [userProfile, setUserProfile] = useState(null);

  // useEffect(() => {

  //   console.log({isAuthenticated, user, userProfile, getAccessTokenSilently})

  //   const getProfile = async () => {
  //     try {
  //       const accessToken = await getAccessTokenSilently();
  //       const response = await fetch(`https://your-api.example.com/user`, {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       });
  //       const profile = await response.json();
  //       setUserProfile(profile);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   if (isAuthenticated) {
  //     getProfile();
  //   }
  // }, [isAuthenticated, getAccessTokenSilently]);

  // if (!isAuthenticated) {
  //   return <div>Please log in to see your profile information.</div>;
  // }

  // if (!userProfile) {
  //   return <div>Loading user profile...</div>;
  // }

  return (
    <>
      {/* <h1>User Profile</h1>
      <p>Name: {user?.name}</p>
      <p>Email: {user?.email}</p>
      <p>Profile Information: {JSON.stringify(userProfile)}</p> */}
      {children}
    </>
  );
};